import { render, staticRenderFns } from "./zhongjian.vue?vue&type=template&id=31163747&scoped=true"
import script from "./zhongjian.vue?vue&type=script&lang=js"
export * from "./zhongjian.vue?vue&type=script&lang=js"
import style0 from "./zhongjian.vue?vue&type=style&index=0&id=31163747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31163747",
  null
  
)

export default component.exports